import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ADMIN_ROLES = new Set(["COUNTRY_ADMIN", "SYSTEM_ADMIN"]);

export default function AdminRoute({ children }) {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (!isAuthenticated || !ADMIN_ROLES.has(user?.role)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}
